module.exports = __webpack_public_path__ + "img/emoji_39.27d481bb.png";